import { format, addDays, differenceInDays } from 'date-fns';

export const convertTime12to24 = time12h => {
  const [time, modifier] = time12h.split(' ');

  // eslint-disable-next-line prefer-const
  let [hours, minutes] = time.split(':');

  if (hours === '12') {
    hours = '00';
  }

  if (modifier === 'PM') {
    hours = parseInt(hours, 10) + 12;
  }

  return `${hours}:${minutes}`;
};

export const formatDuration = duration => {
  if (parseInt(duration) < 0) return 'Invalid time';
  if (parseInt(duration) > 24 * 60 * 3) return 'More than 3 days';
  if (parseInt(duration) < 60) return `${duration} mins (appx.)`;

  const minutes = duration % 60;
  let hours = ~~(duration / 60);
  let days;
  if (hours > 24) {
    days = ~~(hours / 24);
    hours = hours % 24;
  }

  return `${days ? `${days} day ` : ''}${hours} hr ${minutes} mins (appx.)`;
};

export const setDateAsTomorrow = url =>
  url
    .replace(
      /departDate=\d{1,2}-\d{1,2}-\d{4}/,
      `departDate=${format(addDays(new Date(), 1), 'dd-MM-yyy')}`
    )
    .replace(/travelDate/g, `${format(addDays(new Date(), 1), 'dd-MM-yyy')}`);

export const getDifferenceInDays = (dateString1, dateString2) => {
  if (!dateString1 || !dateString2) return null;

  const date1Info = dateString1.split('-').map(numberString => numberString++);
  const date2Info = dateString2.split('-').map(numberString => numberString++);

  const date1 = new Date(date1Info[2], date1Info[1] - 1, date1Info[0]);
  const date2 = new Date(date2Info[2], date2Info[1] - 1, date2Info[0]);

  return differenceInDays(date2, date1);
};
